import { IAppBarConfig, IAppBarMenuConfig } from '@hooks/useWebviewCallback';
import { getAppSelectCityRedirectUrl } from '@helpers/client/getAppSelectCityRedirectUrl';

export const APPBAR_REPORT_CONFIG: IAppBarConfig = {
  back_button_color: '#121212',
  is_appbar_transparent: true,
  ignore_blur: true,
};

export const APPBAR_REPORT_CONFIG_SOLID: IAppBarConfig = {
  back_button_color: '#121212',
  is_appbar_transparent: false,
  background_color: '#FFFFFF',
};

export const DARK_THEME_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#121212',
  back_button_color: '#FFFFFF',
  is_appbar_transparent: false,
  status_icon_brightness: "light",
};

export const LIGHT_THEME_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#ffffff',
  back_button_color: '#121212',
  is_appbar_transparent: false,
  status_icon_brightness: "dark",
};

export const CITY_SELECTION_MODAL_APPBAR_CONFIG: IAppBarConfig = {
  show_back_button: false,
  is_appbar_transparent: true,
  ignore_blur: true,
};

export const COMPLETE_TRANSPARENT_APPBAR_CONFIG: IAppBarConfig = {
  show_back_button: false,
  is_appbar_transparent: true,
  ignore_blur: true,
};

export const TRANSPARENT_APPBAR_CONFIG: IAppBarConfig = {
  is_appbar_transparent: true,
  ignore_blur: true,
  back_button_color: '#FFFFFF',
  status_icon_brightness: "light",
};

export const SEARCH_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#FFFFFF',
  back_button_color: '#121212',
  is_appbar_transparent: false,
  status_icon_brightness: 'dark',
};

export const SELECT_CITY_PAGE_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#FFFFFF',
  back_button_color: '#121212',
  is_appbar_transparent: false,
  status_icon_brightness: 'dark',
};

export const COLLECTION_HEADER_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#0a1f08',
  back_button_color: '#FFFFFF',
  is_appbar_transparent: false,
  status_icon_brightness: "light",
};

export const CARDROP_HEADER_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#000000',
  back_button_color: '#FFFFFF',
  is_appbar_transparent: false,
  status_icon_brightness: "light",
};

export const CARDROP_TandC_HEADER_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#1a1a1a',
  back_button_color: '#FFFFFF',
  is_appbar_transparent: false,
  status_icon_brightness: "light",
};

export const CARDROP_WINNER_HEADER_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#07080D',
  back_button_color: '#FFFFFF',
  is_appbar_transparent: false,
  status_icon_brightness: "light",
};

export const CARDROP_WINNER_TandC_HEADER_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#030403',
  back_button_color: '#FFFFFF',
  is_appbar_transparent: false,
  status_icon_brightness: "light",
};

export const appbarConfig = ({
  backgroundColor,
  backButtonColor,
  isAppbarTransparent,
  ignoreBlur,
  statusIconBrightness,
  menuItems = [],
}: IAppBarMenuConfig): IAppBarConfig => ({
  background_color: backgroundColor,
  back_button_color: backButtonColor,
  is_appbar_transparent: isAppbarTransparent,
  ignore_blur: ignoreBlur,
  status_icon_brightness: statusIconBrightness,
  menu_items: menuItems.map((item) => ({
    icon_url: item.iconUrl,
    action_name: item.actionName,
    redirect_url: item.redirectUrl,
    cta_text: item.ctaText,
  })),
});

export const getWishlistAppbarConfig = (
  cityName: string,
  comingFromPathname?: string | null
): IAppBarConfig => ({
  background_color: '#FFFFFF',
  back_button_color: '#121212',
  is_appbar_transparent: false,
  status_icon_brightness: 'dark',
  menu_items: [
    {
      icon_url: 'https://ackodrive-dev.ackoassets.com/_next_static/icons/location-pin-dark.webp',
      action_name: '',
      redirect_url: getAppSelectCityRedirectUrl(comingFromPathname),
      cta_text: cityName,
    },
  ],
});

export const getHelpMeBuyAppbarConfig = (
  cityName: string,
  comingFromPathname?: string | null
): IAppBarConfig => ({
  back_button_color: '#121212',
  is_appbar_transparent: true,
  ignore_blur: true,
  menu_items: [
    {
      icon_url: 'https://ackodrive-dev.ackoassets.com/_next_static/icons/location-pin-dark.webp',
      action_name: '',
      redirect_url: getAppSelectCityRedirectUrl(comingFromPathname),
      cta_text: cityName,
    },
  ],
});

export const PLAIN_LIGHT_APPBAR_CONFIG: IAppBarConfig = {
  background_color: '#FFFFFF',
  back_button_color: '#121212',
  is_appbar_transparent: false,
  status_icon_brightness: 'dark',
};

export const createAppBarConfig = (
  background_color?: string,
  back_button_color?: string,
  isTransparent: boolean = false
): IAppBarConfig => {
  const autoBackButtonColor = back_button_color || (
    background_color && isLightColor(background_color) ? '#000000' : '#FFFFFF'
  );

  return {
    ...(background_color && !isTransparent && { background_color }),
    back_button_color: autoBackButtonColor,
    is_appbar_transparent: isTransparent,
    
  };
};

function isLightColor(hexColor: string): boolean {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 155;
}

